<ng-container [ngTemplateOutlet]="deviceDetectService.isMobile() ? mobileTemplate : desktopTemplate"></ng-container>

<ng-template #loader>
  <div class="modal-body container flex-fill text-center py-5">
    <circular-spinner class="text-success icon-64"></circular-spinner>
  </div>
</ng-template>

<ng-template #errorMessage>
  <div class="modal-header pt-1 mb-1" *ngIf="isModal">
    <h3 class="mt-0 modal-title text-center mx-auto"></h3>
    <button class="btn-close btn-red" (click)="dismiss()"></button>
  </div>
  <div class="mb-4">
    <error-message
      [message]="'I can\'t load the membership plans...' | translate"
      (goBackButtonAction)="loadData()"
      [goBackButtonText]="'Try again' | translate"
      backgroudClass=""
      textColorClass="text-dark"
    />
  </div>
</ng-template>
<ng-template #mobileTemplate>
  @if(isModal) {
  <div class="subscription-modal-header" [ngClass]="{ 'is-kiter': isKiterMembership() }">
    <div [innerHTML]="(membershipPlans$ | async)?.[0]?.product_title ?? ('Membership plans' | translate)"></div>
    <button class="btn-close-modal btn-icon" (click)="dismiss()">
      <i class="icon icon-times"></i>
    </button>
  </div>
  }
  <div
    class="modal-content-subscription overflow-scroll flex-fill"
    [ngClass]="{ 'is-modal': isModal, 'is-kiter': isKiterMembership() }"
  >
    <ng-container *ngIf="membershipPlans$ | async as membershipPlans; else loader">
      <div class="mb-3">
        <div
          class="mt-0 mb-0 modal-title text-center title-membership"
          [ngClass]="{ 'is-modal': isModal, 'is-kiter': isKiterMembership(), 'has-offer': showPromoLabel() }"
        >
          @if(!isModal) {
          <div
            [innerHTML]="
          membershipPlans?.[0]?.product_title ?? ('Membership plans' | translate)"
          ></div>
          }
          <span [ngClass]="{ 'mt-4': isModal }" translate>Maintain Exclusive benefits</span>
        </div>
        @if(showPromoLabel()) {
        <div class="promo-label text-center w-100 text-success" translate>Limited time offer</div>
        }
      </div>

      <div class="mb-3 tab-selector">
        <flat-tab-selector
          [tabs]="tabsForMobile()"
          [currentIndex]="tabIndex()"
          (indexChange)="onTabIndexChange($event)"
          class="d-block w-100"
        ></flat-tab-selector>
      </div>
      @for(membership of presentationTableDataMobile(); track membership; let idx = $index) {
      <ng-container
        [ngTemplateOutlet]="boxMembership"
        [ngTemplateOutletContext]="{membership, membershipPlans}"
      ></ng-container>
      }
      <ng-container [ngTemplateOutlet]="benefitsTemplate" [ngTemplateOutletContext]="{membershipPlans}"></ng-container>
      <div class="mt-5"></div>
      <ng-container *ngTemplateOutlet="faqTemplate"></ng-container>
    </ng-container>
  </div>
</ng-template>
<ng-template #desktopTemplate>
  <div
    class="modal-content-subscription position-relative overflow-scroll flex-fill"
    [ngClass]="{ 'is-modal': isModal, 'is-kiter': isKiterMembership() }"
  >
    @if(isModal) {
    <button class="btn-close-modal btn-icon" (click)="dismiss()">
      <i class="icon icon-times"></i>
    </button>
    }
    <ng-container *ngIf="membershipPlans$ | async as membershipPlans; else loader">
      <div
        class="mt-0 modal-title text-center title-membership"
        [ngClass]="{ 'is-modal': isModal, 'has-offer': showPromoLabel() }"
      >
        <div
          [innerHTML]="
        membershipPlans?.[0]?.product_title ?? ('Membership plans' | translate)"
        ></div>

        <span translate>Maintain Exclusive benefits</span>
      </div>
      @if(showPromoLabel()) {
      <div class="promo-label text-center w-100 text-success" translate>Limited time offer</div>
      }
      <div class="d-flex flex-col justify-content-center">
        @for(membership of presentationTableDataDesktop(); track membership; let idx = $index) {

        <ng-container
          [ngTemplateOutlet]="boxMembership"
          [ngTemplateOutletContext]="{membership, membershipPlans}"
        ></ng-container>

        }
      </div>
      <ng-container [ngTemplateOutlet]="benefitsTemplate" [ngTemplateOutletContext]="{membershipPlans}"></ng-container>

      <div class="mt-5"></div>
      <ng-container *ngTemplateOutlet="faqTemplate"></ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #faqTemplate>
  @if(faq(); as faq) {
  <h3 translate class="text-center position-relative">
    FAQ
    <span
      class="position-absolute d-none faq-all small"
      (click)="dismiss(); navDataService.navigate('/help/faq')"
      translate
      >See All</span
    >
  </h3>
  <div class="row text-start">
    <div *ngFor="let question of faq; let i = index" class="col-12 col-md-6">
      <ngb-accordion class="d-block my-1">
        <ngb-panel [id]="'faq-panel-' + i">
          <ng-template ngbPanelTitle>
            <div class="row align-items-center faq-title" [ngClass]="{ 'is-kiter': isKiterMembership() }">
              <div class="col-1 text-start">
                <i class="icon icon-16 icon-info-circle"></i>
              </div>
              <div class="col icon-16" [innerHTML]="question.title"></div>
              <div class="col-1 text-end p-0 pe-3">
                <i class="icon icon-32 icon-angle-up"></i>
              </div>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="extra-small" [innerHTML]="question.body"></div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
  </div>
  }
</ng-template>

<ng-template #boxMembership let-membership="membership" let-membershipPlans="membershipPlans">
  <div
    class="box-membership"
    #membershipBox
    [attr.index]="membership.index"
    [attr.id]="'membership_' + membership.index"
  >
    <div class="title">
      <span class="text-uppercase">{{ membership.field_membership_plan }}</span
      ><br /><br />
      @if(membership.discount) {
      <div class="d-flex justify-content-between">
        <div>
          {{ generatePriceMonth(membership.priceWithDiscount) | formatCurrency : membership.price__currency_code : true
          }}<span class="sub-month fw-normal">/{{ 'Month' | translate }}</span>
        </div>
        <div class="discount bg-success">{{ membership.discount }}% {{ 'OFF' | translate }}</div>
      </div>
      <div class="old-price">
        {{ generatePriceMonth(membership.price) | formatCurrency : membership.price__currency_code : true }}/{{
          'Month' | translate
        }}
      </div>
      <div class="sub-title">
        {{ membership.priceWithDiscount | formatCurrency : membership.price__currency_code : true }}
        <span class="fw-normal">{{ 'Billed Yearly' | translate }}</span>
      </div>
      <div class="old-price">
        {{ membership.price | formatCurrency : membership.price__currency_code : true }}
        {{ 'Billed Yearly' | translate }}
      </div>
      }@else {
      {{ generatePriceMonth(membership.price) | formatCurrency : membership.price__currency_code : true
      }}<span class="sub-month fw-normal">/{{ 'Month' | translate }}</span>
      <div class="sub-title">
        {{ membership.price | formatCurrency : membership.price__currency_code : true }}
        <span class="fw-normal">{{ 'Billed Yearly' | translate }}</span>
      </div>
      }
      <div class="cancel" translate>Cancel any time</div>
      @if(membership.field_membership_plan === 'Plus' || membershipPlans.length === 1) {
      <div class="most-popular" translate>Most Popular</div>
      }
    </div>
    <div class="body-membership">
      <div class="d-flex justify-content-center">
        <button
          class="select-btn d-flex align-items-center justify-content-center"
          [disabled]="buttonPayDisabled()"
          (click)="actionForPay(membership)"
        >
          @if(membership.isProcessing()) {
          <circular-spinner class="text-white icon-16"></circular-spinner>
          }@else {
          <span translate>Select</span>
          }
        </button>
      </div>
      <ul class="checklist">
        @for(benefit of membership.field_features_export; track benefit; let i = $index) {
        <li>
          @if (benefit.included === '1') {

          <div class="check check-ok">
            <i class="icon icon-check"></i>
          </div>
          }@else {
          <div class="check check-ko">
            <i class="icon icon-times"></i>
          </div>
          }
          <span>{{ benefit.title | stripHtmlTag }}</span>
        </li>
        }
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #benefitsTemplate let-membershipPlans="membershipPlans">
  <div class="benefits">
    <div class="title" translate>Benefits Details</div>
    @for(benefit of membershipPlans[0]?.field_benefits_export; track benefit) {
    <div class="container-benefit">
      <div class="title-benefit" [innerHTML]="benefit.titleMobile"></div>
      <div class="box-benefit">
        <span [innerHTML]="benefit.detailsMobile"></span>
        @if (benefit.link) {
        <a
          class="link-benefit text-center"
          [href]="benefit.link | localize"
          target="_blank"
          [innerHTML]="benefit.linkText"
        ></a>
        }
      </div>
    </div>
    }
  </div>
</ng-template>
<!-- <ng-template #desktopTemplateOld>
  <ng-container *ngIf="!hasError(); else errorMessage">
    <ng-container *ngIf="membershipPlans$ | async as membershipPlans; else loader">
      <div class="modal-header pt-1 mb-1">
        <span
          [ngClass]="{ h1: !isModal, h3: isModal }"
          class="mt-0 mb-0 modal-title text-center mx-auto"
          id="modal-basic-title"
        >
          {{
      membershipPlans?.[0]?.product_title ?? ('Membership plans' | translate)
          }}
        </span>
        <button class="btn-close btn-red" (click)="dismiss()" *ngIf="isModal"></button>
      </div>
      <div class="modal-body text-center py-2">
        <div class="extra-small" *ngIf="membershipPlans" [innerHTML]="membershipPlans[0]?.body"></div>
        <div class="d-block d-md-none swiper-benefit">
          <swiper class="swiper pb-5" [config]="sliderConfig" *ngIf="activeProduct">
            <ng-template swiperSlide *ngFor="let benefit of activeProduct?.field_benefits_export">
              <div class="row justify-content-center mb-4">
                <div class="col-10">
                  <image-srcset [width]="295" [height]="295" [item]="benefit.image"></image-srcset>
                </div>
              </div>
              <div class="extra-small my-3" [innerHTML]="benefit.details"></div>
            </ng-template>
            <span
              slot="container-start"
              class="button-prev start-0 position-absolute button-navigation-swiper l-0 pointer"
            >
              <i class="icon icon-64 icon-angle-left"></i>
            </span>
            <span slot="container-end" class="button-next position-absolute button-navigation-swiper r-0 pointer">
              <i class="icon icon-64 icon-angle-right"></i>
            </span>
            <div class="swiper-pagination my-3"></div>
          </swiper>
        </div>
        <div class="d-none d-md-block swiper-benefit">
          <swiper class="swiper mb-4" [config]="sliderConfig" *ngIf="activeProduct">
            <ng-template swiperSlide *ngFor="let benefit of activeProduct?.field_benefits_export">
              <div class="d-flex mx-2 mb-1 flex-column justify-content-center align-items-center">
                <image-srcset [width]="158" [height]="158" [item]="benefit.image"></image-srcset>
                <div class="extra-small my-3" [innerHTML]="benefit.details"></div>
              </div>
            </ng-template>
            <span
              slot="container-start"
              class="button-prev start-0 position-absolute button-navigation-swiper l-0 pointer"
            >
              <i class="icon icon-64 icon-angle-left"></i>
            </span>
            <span slot="container-end" class="button-next position-absolute button-navigation-swiper r-0 pointer">
              <i class="icon icon-64 icon-angle-right"></i>
            </span>
          </swiper>
        </div>
        <div *ngIf="hours !== '00' || minutes !== '00' || seconds !== '00'" class="row justify-content-center">
          <div *ngIf="hours" class="col-3 col-lg-1 mb-5 mx-1 p-0">
            <h2 class="m-0 text-danger text-shadow">{{ hours }}</h2>
            <div class="small">Hours</div>
          </div>
          <div *ngIf="minutes" class="col-3 col-lg-1 mb-5 mx-1 p-0">
            <h2 class="m-0 text-danger text-shadow">{{ minutes }}</h2>
            <div class="small">Minutes</div>
          </div>
          <div *ngIf="seconds" class="col-3 col-lg-1 mb-5 mx-1 p-0">
            <h2 class="m-0 text-danger text-shadow">{{ seconds }}</h2>
            <div class="small">Seconds</div>
          </div>
        </div>
        <div class="mt-5 d-block d-md-none">
          <div class="row">
            <div class="col px-0" *ngFor="let product of membershipPlans; let i = index">
              <div
                (click)="selectProduct(product)"
                class="p-2 rounded-top"
                [ngClass]="{
                  'bg-light-transparent-4': activeProduct?.variation_id === product.variation_id,
                  'mt-n5': i === 1
                }"
              >
                <span class="small" *ngIf="i === 1" translate>MOST POPULAR<br /></span>
                <h4 class="mb-2 mt-0">{{ product.field_membership_plan }}</h4>
                <div *ngIf="activeProduct?.variation_id !== product.variation_id">
                  <span *ngIf="product.price_discount !== product.price">
                    <s>{{ product.price }} {{ product.price__currency_code }}</s>
                    <span>{{ product.price_discount }} {{ product.price__currency_code }}</span>
                  </span>
                  <span *ngIf="product.price_discount === product.price"
                    >{{ product.price }} {{ product.price__currency_code }}</span
                  >
                </div>
                <button
                  *ngIf="activeProduct?.variation_id === product.variation_id"
                  class="mb-0 py-2 box-shadow btn btn-success rounded btn-sm btn-block"
                  [disabled]="buttonPayDisabled()"
                  (click)="actionForPay(product)"
                >
                  <span *ngIf="product.price_discount !== product.price">
                    <s>{{ product.price }} {{ product.price__currency_code }}</s>
                    <span>{{ product.price_discount }} {{ product.price__currency_code }}</span>
                  </span>
                  <span *ngIf="product.price_discount === product.price">
                    {{ product.price }} {{ product.price__currency_code }}</span
                  >
                </button>
                <i
                  class="icon icon-32 icon-angle-right rotate-90"
                  *ngIf="activeProduct?.variation_id === product.variation_id"
                ></i>
              </div>
            </div>
          </div>
          <div class="row text-start bg-light-transparent-4 rounded" *ngIf="activeProduct" [ngClass]="featuresRadious">
            <div class="col-12">
              <h3 class="text-center mt-3" translate>Features</h3>
            </div>
            <div class="col-12 mb-3 px-2" *ngFor="let feature of activeProduct?.field_features_export; last as isLast">
              <div [ngClass]="{ 'border-bottom border-white': !isLast }">
                <div class="row px-2">
                  <div class="col-2 px-1 small text-center"><i class="icon icon-32" [ngClass]="feature.icon"></i></div>
                  <div class="col-8 px-1 extra-small" [innerHTML]="feature.details"></div>
                  <div class="col-2 px-1 small align-self-center text-center">
                    <i class="icon icon-32 icon-check" *ngIf="+feature.included"></i
                    ><i class="icon icon-32 icon-times" *ngIf="!+feature.included"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="my-3" translate>Billed yearly<br /><span translate>Cancel anytime</span></div>
        </div>
        <div [ngClass]="{ 'col-8': !isModal }" class="mb-5 mx-auto d-none d-md-block">
          <div class="row mt-5">
            <div
              class="col-md-4"
              [ngClass]="{ 'mt-n5': i === 1 }"
              *ngFor="let memberS of membershipPlans; let i = index"
            >
              <div class="card card-pricing bg-primary-gradient price-card">
                <div class="card-body">
                  <div [ngClass]="{ h3: !isModal, h6: isModal }" class="category text-white">
                    <span *ngIf="i === 1" translate>MOST POPULAR<br /></span>{{ memberS.field_membership_plan }}
                  </div>
                  <div class="icon icon-primary mb-6">
                    <i class="icon icon-star m-auto py-0"></i>
                  </div>
                  <button
                    class="py-2 box-shadow btn btn-success rounded-1 btn-sm btn-block mb-2"
                    [disabled]="buttonPayDisabled()"
                    (click)="actionForPay(memberS)"
                    translate
                  >
                    <span *ngIf="memberS.price_discount !== memberS.price">
                      <s>{{ memberS.price }} {{ memberS.price__currency_code }}</s>
                      <span>{{ memberS.price_discount }} {{ memberS.price__currency_code }}</span>
                    </span>
                    <span *ngIf="memberS.price_discount === memberS.price"
                      >{{ memberS.price }} {{ memberS.price__currency_code }}</span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
          @if(presentationTableData(); as tableData) {
          <div class="row m-0 border rounded-1 p-3">
            <table class="table w-100">
              <thead>
                <tr>
                  <th width="50%" class="border-bottom text-left text-primary p-0 fw-bold" translate>Benefits</th>
                  @for(plan of tableData.memberships; track plan.name) {
                  <th width="17%" class="border-bottom fw-bold text-primary p-0 fw-bold">
                    {{ plan.name }}
                  </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for(benefit of tableData.benefits; track benefit.title; let i = $index; let last = $last) {
                <tr class="">
                  <td class="pt-3 text-start p-0" translate [ngClass]="{ 'border-0': last }">
                    <p class="m-0 extra-small" [innerHTML]="benefit.title" translate></p>
                    <p class="m-0 extra-small" [innerHTML]="benefit.description" translate></p>
                  </td>
                  @for(plan of tableData.memberships; track plan.name) {
                  <td class="text-center p-0 pt-3" [ngClass]="{ 'border-0': last }">
                    @if(plan.benefits[i]) {
                    <i class="icon icon-32 icon-check text-green"></i>
                    }@else{
                    <i class="icon icon-32 icon-times text-danger"></i>
                    }
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
          </div>
          }
        </div>
        <div class="my-4 text-center" *ngIf="membershipPlans.length === 0">
          <a
            class="btn btn-success rounded-1"
            (click)="navDataService.navigate('https://www.ikointl.com/roles-fees-management', true)"
            translate=""
          >
            Renew Membership
          </a>
        </div>

        <ng-container *ngTemplateOutlet="faqTemplate"></ng-container>
       
      </div>
    </ng-container>
  </ng-container>
</ng-template> -->
